(() => {
  if (window.llbWholesaleControls) {
    window.llbWholesaleControls.init(document);
    return;
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slideControllers = new WeakMap();
  function init(root) {
    root.querySelectorAll('.llb-original-content [data-hero-slideshow]').forEach(slideshow => {
      if (slideControllers.has(slideshow)) return;
      const slides = [...slideshow.querySelectorAll('[data-hero-slide]')];
      const container = slideshow.closest('[data-hero-root]');
      const controls = container.querySelectorAll('[data-hero-control]');
      controls.forEach(button => { button.hidden = slides.length < 2; });
      if (!slides.length) return;
      let active = Math.max(0, slides.findIndex(slide => slide.dataset.active === 'true'));
      const show = next => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          slide.dataset.active = String(index === active);
          slide.setAttribute('aria-hidden', String(index !== active));
        });
      };
      show(active);
      controls.forEach(button => button.addEventListener('click', () => show(active + (button.dataset.heroControl === 'prev' ? -1 : 1))));
      slideControllers.set(slideshow, {slides, show});
    });
    root.querySelectorAll('.llb-original-content #products-carousel').forEach(container => {
      if (container.dataset.bound) return;
      container.dataset.bound = 'true';
      const scroller = container.querySelector('.llbc-carousel-scroll');
      if (!scroller) return;
      [['.llbc-carousel-prev', -1], ['.llbc-carousel-next', 1]].forEach(([selector, direction]) => {
        container.querySelector(selector)?.addEventListener('click', () => scroller.scrollBy({left: direction * scroller.clientWidth * .75, behavior: reducedMotion ? 'instant' : 'smooth'}));
      });
    });
    root.querySelectorAll('.llb-original-content .llbc-partner-carousel').forEach(container => {
      if (container.dataset.bound) return;
      container.dataset.bound = 'true';
      const toggle = () => {container.dataset.paused = String(container.dataset.paused !== 'true');};
      container.addEventListener('click', toggle);
      container.addEventListener('keydown', event => {
        if (['Enter', ' '].includes(event.key)) {event.preventDefault(); toggle();}
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.matches('[data-hero-slide]') ? event.target : event.target.closest('[data-hero-slide]');
    if (!slide) return;
    const controller = slideControllers.get(slide.closest('[data-hero-slideshow]'));
    if (controller) controller.show(controller.slides.indexOf(slide));
  });
  window.llbWholesaleControls = {init};
  init(document);
})();
